module.exports = __webpack_public_path__ + "img/20221227162032.cc1d6322.png";